module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-65-Medium.092a99ee.ttf";